export const SLIDES_TO_SHOW = 4;
export const SLIDE_BORDER_WIDTH = 1;
export const SLIDE_BORDER_WIDTH_ACTIVE = 2;
export const SLIDE_CELL_SPACING = 4;

export const MAX_IMAGE_HEIGHT = ['19vw', '10vw', '9vw', '7vw'];
